import * as e from "react";
import c from "../lib/IconBase.es.js";
import s from "../defs/Briefcase.es.js";
const o = e.forwardRef((r, a) => /* @__PURE__ */ e.createElement(c, { ref: a, ...r, weights: s }));
o.displayName = "BriefcaseIcon";
const i = o;
export {
  i as Briefcase,
  o as BriefcaseIcon
};
